import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import './assets/tailwind.css';
import swell from 'swell-js'
import i18n from './i18n';
import storeData from './store';
import LoadScript from 'vue-plugin-load-script';
import './modules/swell/mixin';

Vue.use(Vuex);
Vue.use(LoadScript);

const store = new Vuex.Store(storeData);

window.VUE_STORE = store;

Vue.config.productionTip = false;

// window.STORE = { NAME: "brand-fashion", KEY: "" }

(async () => {
  try {
    Vue.loadScript("https://code.iconify.design/1/1.0.1/iconify.min.js");

    // TODO: SWELL KEY public
    swell.init(window.VUE_STORE_NAME, window.VUE_STORE_KEY, {
      useCamelCase: true,
      url: '/',//'/',//http://localhost:9981/',
      previewContent: false,
      session: getCookie("swell-session"),
      locale: 'hu-HU',  // getCookie('swell-locale'),
      currency: 'HUF',  // getCookie("swell-currency"),
    });

    //console.log("session: ", getCookie("swell-session"))

    //swell.cart.get();

    Vue.prototype.$swell = swell;
    store.$swell = swell;

    new Vue({
      i18n,
      store,
      render: h => h(App)
    }).$mount('#app');
  } catch (e) {
    console.log(e)
  }
})();

function getCookie(name) {
  const pattern = RegExp(name + '=.[^;]*')
  const matched = document.cookie.match(pattern)
  if (matched) {
    const cookie = matched[0].split('=')
    return cookie[1]
  }
  return false
}


